module.exports = "- Do not use dividers for graphic decoration.\n"